import { Link } from "react-router-dom";

interface partnerUniProps {
  aboutTitle: string;
  aboutDesc: string;
  partnerUniTitle: string;
  partnerUni: string[];
  contactTitle: string;
  contact: string[];
  linkPath?: string;
}

export default function Footer({
  aboutTitle,
  aboutDesc,
  partnerUniTitle,
  partnerUni,
  contactTitle,
  contact,
  linkPath,
}: partnerUniProps) {
  return (
    <footer className="flex flex-col items-center w-full bg-gray-900 text-white py-16 ">
      <div className="flex flex-col md:flex-row justify-between gap-6 max-w-7xl mx-auto px-4">
        <div className="w-full md:w-1/3">
          <h3 className="font-black text-center md:text-left text-3xl md:text-2xl lg:text-3xl mb-2 bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            {aboutTitle}
          </h3>
          <p className="text-gray-400 mb-8 font-medium">{aboutDesc}</p>
        </div>

        <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center md:items-start">
          <h3 className="font-black text-3xl md:text-2xl lg:text-3xl mb-2 bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            {partnerUniTitle}
          </h3>
          <ul className="text-gray-400 gap-x-20 md:justify-between mb-8 font-medium grid grid-cols-2 ">
            {partnerUni.map((uni, index) =>
              linkPath ? (
                <Link
                  key={index}
                  to={linkPath}
                  state={{ scrollToUni: uni }} // Pass the university name in state
                  className="hover:text-white transition-colors duration-300"
                >
                  {uni}
                </Link>
              ) : (
                <li
                  key={index}
                  className="hover:text-white transition-colors duration-300"
                >
                  {uni}
                </li>
              )
            )}
          </ul>
        </div>

        <div className="w-full md:w-1/3 lg:w-1/4 flex flex-col items-center md:items-start">
          <h3 className="font-black text-3xl md:text-2xl lg:text-3xl mb-2 bg-gradient-to-r from-orange-400 via-pink-400 to-purple-400 bg-clip-text text-transparent">
            {contactTitle}
          </h3>
          <ul className="text-gray-400 mb-8 font-medium px-6 md:px-0">
            {contact.map((contact) => (
              <li>{contact}</li>
            ))}
          </ul>
        </div>
      </div>
      <div className="w-full mx-auto border-t border-gray-800 pt-8 text-center">
        <p className="text-gray-500 text-sm font-semibold">
          © 2025 SCS Education. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
